export default __webpack_public_path__ + "static/media/chat.fdee1ca0.svg";